export function applicationConfigurationModelFromDto(dto) {
    const slug = dto.applicationType.slug;
    const isComputerLoginWithAD = slug === 'computer-login';
    const isOffice365 = slug === 'office-365';
    const isEPM = slug === 'enterprise-password-manager';
    const isSaaspassDemo = slug === 'saaspass-demo';
    const isSaaspassMySqlConnector = slug === 'saaspass-my-sql-connector';
    const isOidcConfigSupported = dto.applicationType.oidcConfigSupported;
    const isOidc = dto.applicationType.oidcConfigSupported && slug != 'generic-oauth2' && !slug.endsWith('proxy-sso');
    const isProxySso = dto.applicationType.slug.endsWith('proxy-sso');
    const isSaml = dto.applicationType.saml;
    
    return {
        adDomain: dto.adDomain,
        appDomain: dto.appDomain,
        applicationName: dto.applicationName,
        apiKey:dto.apiKey,
        note: dto.note,
        showNote: dto.showNote,
        applicationTypeId: dto.applicationType.applicationTypeId,
        applicationTypeDisplayName: dto.applicationType.applicationTypeDisplayName,
        companyAdDomains: dto.companyAdDomains,
        configDTO: dto.configDTO,
        configElements: (((dto.configDTO || {}).appConfig || {}).elements || [])
            .map(({name, label, placeholder, value, required, validations}) => {
                const type = (validations || []).map(v => v.type).find(Boolean);
                return {name, label, placeholder, value, required, type};
            }),
        customIconUrl: dto.customIconUrl,
        customLogoUrl: dto.customLogoUrl,
        epmAppSettings: dto.epmAppSettings,
        isComputerLoginWithAD,
        isEPM,
        isOffice365,
        isRunning: dto.status === 'RUNNING',
        samlAppLogo: window.env.urls.samlAppLogo(slug, 'thumb'),
        samlAppLogo2: window.env.urls.samlAppLogo(slug, 'logo'),
        isSaaspassDemo,
        isSaaspassMySqlConnector,
        provisioningUrl: dto.provisioningUrl,
        samlConfigSupported: dto.applicationType.samlConfigSupported,
        samlSigAlg: dto.samlSigAlg,
        samlDigAlg: dto.samlDigAlg,
        samlSigningOpt: dto.samlSigningOpt,
        samlAssEncEnabled: dto.samlAssEncEnabled,
        samlEncCert: dto.samlEncCert,
        samlKeyTransAlg: dto.samlKeyTransAlg,
        samlBlockEncAlg: dto.samlBlockEncAlg,
        samlSessionDurationEnabled: dto.samlSessionDurationEnabled,
        samlSessionDuration: dto.samlSessionDuration,
        isOidcConfigSupported,
        isOidc,
        isSaml,
        isProxySso,
        callbackUrl: dto.callbackUrl,
        oidcScopes: dto.oidcScopes,
        oidcGrants : dto.oidcGrants,
        accessTokenLifetime : dto.accessTokenLifetime,
        samlMetadata: dto.samlMetadata
    };
}

export function applicationConfigurationModelToDto(model) {
    return {
        adDomain: model.adDomain,
        appDomain: model.appDomain,
        applicationName: model.applicationName,
        apiKey: model.apiKey,
        configDTO: model.configDTO && {
            ...model.configDTO,
            appConfig: model.configDTO.appConfig && {
                ...model.configDTO.appConfig,
                elements: model.configElements.map(({name, value}) => ({name, value}))
            },
        },
        epmAppSettings: model.epmAppSettings,
        status: model.isRunning ? 'RUNNING' : 'PAUSED',
        note: model.note,
        showNote: model.showNote,
        provisioningUrl: model.provisioningUrl,
        samlSigAlg: model.samlSigAlg,
        samlDigAlg: model.samlDigAlg,
        samlSigningOpt: model.samlSigningOpt,
        samlAssEncEnabled: model.samlAssEncEnabled,
        samlEncCert: model.samlEncCert,
        samlKeyTransAlg: model.samlKeyTransAlg,
        samlBlockEncAlg: model.samlBlockEncAlg,
        samlSessionDurationEnabled: model.samlSessionDurationEnabled,
        samlSessionDuration: model.samlSessionDuration,
        callbackUrl: model.callbackUrl,
        oidcScopes: model.oidcScopes,
        oidcGrants: model.oidcGrants,
        accessTokenLifetime: model.accessTokenLifetime
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration-form.functions.js